module.exports = __webpack_public_path__ + "95ee8dee1b340a13c2781e97e2fda26c.pdf";